import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    roleList: [],
    trinFormsRoles: [],
    loaded: false
  }
};
const roleListSlice = createSlice({
  name: "roleListInfo",
  initialState,
  reducers: {
    getRoleList: (state, action) => {
      state.value = {
        roleList: action.payload.trinDocsRoles,
        trinFormsRoles: action.payload.trinFormsRoles,
        loaded: true
      };
    }
  }
});
export const { getRoleList } = roleListSlice.actions;
export default roleListSlice.reducer;
